import axios from "axios";
import { localStorageItem } from "../../utils/LocalStorage";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import { APP_CONFIGURATION_KEYS } from "../../utils/Constant";

const API_URL = (localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.ADMIN_URL] || process.env.REACT_APP_ADMIN_API_URL);
const API_PATH = (localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.SSO_URL] || process.env.REACT_APP_TENANT_MANAGER_URL);

export const getDanhSachTaiKhoan = async (parameters: any) => {
    let config = {
        params: parameters
    }
    return axios.get(API_URL + "/users", config);
}

export const changePassword = (data: any) => {
  var url = API_PATH + "/users/password/change";
  return axios.patch(url, data);
};